module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateEditModal",
    attrs: {
      "id": "missionSlotTemplateEditModal",
      "title": _vm.$t('mission.slotTemplate.modal.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionSlotTemplateEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMissionSlotTemplate($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": _vm.missionSlotTemplateEditTitleState,
      "feedback": _vm.missionSlotTemplateEditTitleFeedback,
      "description": _vm.$t('mission.slotTemplate.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateEditData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateEditData.title = $$v
      },
      expression: "missionSlotTemplateEditData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": _vm.missionSlotTemplateEditVisibilityState,
      "feedback": _vm.missionSlotTemplateEditVisibilityFeedback,
      "description": _vm.$t('mission.slotTemplate.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotTemplateEditVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateEditData.visibility),
      callback: function($$v) {
        _vm.missionSlotTemplateEditData.visibility = $$v
      },
      expression: "missionSlotTemplateEditData.visibility"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMissionSlotTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24d1624c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateEditModal.vue
// module id = 489
// module chunks = 0